import React, { memo, useState, useEffect } from 'react'
import { Button, HeadingText, BodyText, Avatar } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PP_LOGGED_OUT_URL } from '../../../../constants/constants'
import { fptiCustomImpression } from '../../../../utils'
import DATAPRIVACY_FPTI from '../../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const TokenExpired = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.EMAIL_LINK_EXPIRED_IMPRESSION)
    }
  }, [])

  const handleLinkClick = (event) => {
    event.preventDefault()
    location.href = PP_LOGGED_OUT_URL
  }
  return (
    <>
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen text-center">
            <div className="flex-center">
              <Avatar
                src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-critical.svg"
                className="focusedimg"
                alt="expired"
              />
            </div>

            <HeadingText size="sm" className="">
              <Message id="dsrLoggedout.linkexpiredpage.header" />
            </HeadingText>

            <BodyText className="requestForm-section-desc">
              <Message id="dsrLoggedout.linkexpiredpage.content" />
            </BodyText>

            <BodyText className="requestForm-section-desc">
              <span>
                <Message id="dsrLoggedout.linkexpiredpage.requestid" />
              </span>
              <strong className="s-value"> {props.reqid}</strong>
            </BodyText>

            <BodyText>
              <Button
                theme="v2"
                tertiary
                onClick={handleLinkClick}
                className=""
              >
                <Message id="dsrLoggedout.linkexpiredpage.createanewrequest" />
                <span className="tertiary-button--icon" />
              </Button>
            </BodyText>
          </section>
        </div>
      </section>
    </>
  )
})
TokenExpired.displayName = 'TokenExpired'

export default TokenExpired
